import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-button-datetimepicker',
  templateUrl: './button-datetimepicker.component.html',
  styleUrls: ['./button-datetimepicker.component.css']
})
export class ButtonDatetimepickerComponent implements OnInit {

  @Input() onlyDate = false;
  @Input() onlyTime = false;
  @Input()
  set min(value) {
    this._min = value ? new Date(value) : null;
    this._min.setHours(0, 0, 0);
    this._date = this._date || this._min;
  }
  get min() { return this._min }
  @Input()
  set max(value) {
    this._max = value ? new Date(value) : null;
    this._max.setHours(11, 59, 59);
  }
  get max() { return this._max; }
  @Output() dateChange = new EventEmitter();
  @Output() dateSelected = new EventEmitter();
  @Input() value = 'Select Date';

  @Input()
  set date(value) {
    // console.log('set_date', value);
    this._date = value ? new Date(value) : null;
  }

  get date() {
    return this._date;
  }

  public pickerType: string;

  private _date = null;
  private _min = null;
  private _max = null;

  constructor() { }

  ngOnInit() {
    // this.settings = {
    //   // bigBanner: true,
    //   timePicker: !this.onlyDate,
    //   format: this.onlyDate ? 'yyyy-MM-dd' : 'yyyy-MM-dd hh:mm a',
    //   closeOnSelect: true
    // }
    this.pickerType = this.onlyDate ? 'calendar' : this.onlyTime ? 'timer' : 'both';
  }

  onDateSelect(event) {
    this.dateSelected.emit(event.value);
    this.dateChange.emit(event.value);
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/button-datetimepicker/button-datetimepicker.component.ts